import React from 'react';
import styles from './LimitButton.module.css';

const LimitButton = ({ children, value, isActive, style, onClick }) => (
  <button
    type="button"
    className={`naked-button ${styles.button} ${isActive ? styles.active : ''}`}
    style={style}
    onClick={() => onClick(value)}
  >
    {children}
  </button>
);

export default LimitButton;
